<template>
  <div class="landing-api" :class="{loaded}">
    <Header />
    <div class="landing__main-window">
      <div class="content">
        <div class="landing__main-wrapper">
          <img class="landing__main-image" src="../images/landing/api-main.webp" alt="" decoding="async">
          <InfoBlock
            class="landing__main-right"
            :message="this.$i18n.t('apiMessage')"
            :description="this.$i18n.t('apiDescription')"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <Advantages :advantages="advantages"/>
      <OnePlace
        :title="this.$i18n.t('apiOnePlaceTitle')"
        :description="this.$i18n.t('apiOnePlaceDescription')"
        :options="[
          {
            title: this.$i18n.t('apiOnePlaceTitle1'),
            desc: this.$i18n.t('apiOnePlaceOption1')
          },
          {
            title: this.$i18n.t('apiOnePlaceTitle2'),
            desc: this.$i18n.t('apiOnePlaceOption2')
          },
          {
            title: this.$i18n.t('apiOnePlaceTitle3'),
            desc: this.$i18n.t('apiOnePlaceOption3')
          },
          {
            title: this.$i18n.t('apiOnePlaceTitle4'),
            desc: this.$i18n.t('apiOnePlaceOption4')
          }
        ]"
        :images="apiScreenshots"
      />
    </div>
    <AllBenefits
        :title="this.$i18n.t('apiBenefitsTitle')"
        :description="this.$i18n.t('apiBenefitsDescription')"
        :benefits="[
          {
            title: this.$i18n.t('apiBenefitTitle1'),
            description: this.$i18n.t('apiBenefitDescription1')
          },
          {
            title: this.$i18n.t('apiBenefitTitle2'),
            description: this.$i18n.t('apiBenefitDescription2')
          },
          {
            title: this.$i18n.t('apiBenefitTitle3'),
            description: this.$i18n.t('apiBenefitDescription3')
          }
        ]"
        :benefit-icons="apiBenefitIcons"
    />
    <div class="content">
      <CertifiedBy/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '../landing/Header.vue'
import InfoBlock from './InfoBlock.vue'
import Advantages from '../landing/Advantages.vue'
import OnePlace from '../landing/OnePlace.vue'
import AllBenefits from '../landing/AllBenefits.vue'
import CertifiedBy from '../landing/CertifiedBy.vue'
import Footer from '../landing/Footer.vue'
import apiScreenshotOne from '../images/api/1_en.png'
import apiScreenshotTwo from '../images/api/2_en.png'
import apiScreenshotThree from '../images/api/3_en.png'
import apiScreenshotFour from '../images/api/4_en.png'
import apiBenefitOne from '../images/api/1.svg'
import apiBenefitTwo from '../images/api/2.svg'
import apiBenefitThree from '../images/api/3.svg'
import '../landing/landing.scss'
import { AmplitudeEvent } from 'components/shared/amplitude.js';
export default {
  components: {
    Header,
    InfoBlock,
    Advantages,
    OnePlace,
    AllBenefits,
    Footer,
    CertifiedBy,
  },
  data(){
    return {
      loaded: false,
      apiScreenshots: [
        apiScreenshotOne,
        apiScreenshotTwo,
        apiScreenshotThree,
        apiScreenshotFour
      ],
      apiBenefitIcons: [apiBenefitOne, apiBenefitTwo, apiBenefitThree]
    }
  },
  computed: {
    advantages() {
      return [
        this.$i18n.t('advantage_api_1'),
        this.$i18n.t('advantage_api_2'),
        this.$i18n.t('advantage_api_3')
      ]
    }
  },
  created() {
    document.querySelector('meta[name="viewport"]').setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    document.querySelector('meta[name="description"]').setAttribute("content", "Use the DRCT API and receive the best integration experience that you have ever had.");
    document.title = "DRCT for developers";

    new AmplitudeEvent("Landing")
  },
  mounted(){
    this.loaded = true

    setTimeout(() => {
      Intercom("onShow", function() {
        new AmplitudeEvent("Intercome")
      });
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.landing-api {
    opacity: 0;
    transition: opacity .3s;

    &.loaded {
      opacity: 1;
    }

  ::v-deep(.advantages) {
    margin-top: 0;
  }
}

.landing__main-image {
  height: auto;
  width: 434px;
}

.landing__main-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.landing__main-window {
  padding-top: 126px;
  padding-bottom: 200px;
  background-image: url("../images/landing/api-gradient.webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left;

  @media (max-width: 767px) {
    padding-bottom: 100px;
    padding-top: 0;
  }
}

.content {
  width: 1010px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 20px;
    overflow: hidden;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    padding: 0 24px;
  }

  @media (max-width: 413px) {
    padding: 0 8px;
  }

  ::v-deep(.certified) {
    @media (max-width: 767px) {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  }
}

.landing__main-wrapper {
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
    margin-bottom: 16px;
  }

  .landing__main-image {
    height: auto;
    width: 434px;

    @media (max-width: 767px) {
      margin-bottom: 36px;
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }
}

.landing__main-right {
  width: 413px;

  @media (max-width: 767px) {
    width: 100%;
  }

  h2 {
    @media (max-width: 413px) {
      font-size: 27px;
    }
  }

  p {
    @media (max-width: 413px) {
      font-size: 14px;
    }
  }
}
</style>
